// Plochý seznam položek se VZHLEDEM menu (LeadIcon + label + čudlík osamostatnit) — reuse `MenuRow`
// a `MenuConfigContext`. Bez vlastního pozicování/portálu; vloží se do libovolného popoveru
// (např. historie agend v taskbaru). Klik na řádek = onOpen, čudlík = onDetach.

import { type ReactNode } from 'react';

import { MENU_DENSITY } from './density';
import { MenuConfigContext, type MenuConfig } from './menuConfigContext';
import { menuTypeIcon } from './menuTypeIcon';
import { MenuRow } from './MenuRow';
import type { MenuDensity, MenuIconResolver, MenuItemNode } from './menuTypes';

export interface MenuItemListProps {
  readonly items: readonly MenuItemNode[];
  /** Klik na řádek (otevřít v ploše). */
  readonly onOpen: (node: MenuItemNode) => void;
  /** Čudlík osamostatnit (otevřít v plovoucím okně). */
  readonly onDetach: (node: MenuItemNode) => void;
  readonly density?: MenuDensity;
  readonly iconForNode?: MenuIconResolver;
  readonly detachAlways?: boolean;
  /** Co zobrazit při prázdném seznamu. */
  readonly empty?: ReactNode;
}

export function MenuItemList({
  items,
  onOpen,
  onDetach,
  density = 'compact',
  iconForNode = menuTypeIcon,
  detachAlways = true,
  empty,
}: MenuItemListProps) {
  if (items.length === 0) {
    return empty === undefined ? null : <>{empty}</>;
  }

  const config: MenuConfig = {
    density,
    densityTokens: MENU_DENSITY[density],
    separators: 'lines',
    detachAlways,
    iconForNode,
    onOpen,
    onDetach,
  };

  return (
    <MenuConfigContext.Provider value={config}>
      <div className="flex flex-col">
        {items.map((node) => (
          <MenuRow key={node.id} node={node} onActivate={() => onOpen(node)} />
        ))}
      </div>
    </MenuConfigContext.Provider>
  );
}
